<template>
  <div class="mine">
    <div class="top-line">
      <div class="small-button" @click="toBack()">返回</div>
      <span class="title">我的主页</span>
    </div>
    <div class="content">
      <div class="menu">
        <img
          class="teacher-img"
          :src="userInfo.avatar || require('../../../images/teacherCover.png')"
          alt=""
        />
        <div class="teacher-name">{{ userInfo.nick_name }}</div>
        <div class="teacher-school">{{ userInfo.school_name }}</div>
        <div
          :class="{ 'menu-item': true, 'cur-menu': menuIndex == index }"
          v-for="(item, index) in menu"
          :key="item"
          @click="changeMenu(index)"
        >
          {{ item }}
        </div>
      </div>

      <div class="rel" v-if="menuIndex == 0">
        <teacher-resource></teacher-resource>
      </div>
      <div class="rel" v-if="menuIndex == 1">
        <my-download></my-download>
      </div>
      <div class="rel" v-if="menuIndex == 2">
        <my-collect></my-collect>
      </div>
      <div class="rel" v-if="menuIndex == 3">
        <my-follow></my-follow>
      </div>
      <div class="rel" v-if="menuIndex == 4">
        <my-fans></my-fans>
      </div>
      <div class="rel" v-if="menuIndex == 5">
        <!-- <edit-info></edit-info> -->
        <my-info @onRefreshImg="refreshImg"></my-info>
      </div>
      <!-- <div class="rel" v-if="menuIndex == 6">
        <edit-info></edit-info>
      </div> -->
    </div>
  </div>
</template>

<script>
import MyCollect from '../../components/myCollect.vue'
import MyDownload from '../../components/myDownload.vue'
import MyFans from '../../components/myFans.vue'
import MyFollow from '../../components/myFollow.vue'
import EditInfo from '../../components/editInfo.vue'
import teacherResource from '../../components/teacherResource.vue'
import MyInfo from '../../components/myInfo.vue'

export default {
  components: {
    teacherResource,
    MyDownload,
    MyCollect,
    MyFollow,
    MyFans,
    EditInfo,
    MyInfo,
  },
  name: 'TeacherResource',
  data: () => ({
    menu: [
      '我的资源',
      // '我的文件',
      '我的下载',
      '我的收藏',
      '我的关注',
      '我的粉丝',
      '我的信息',
      // '修改信息',
    ],
    menuIndex: 0,
    userInfo: {},
  }),

  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('yey-user'))
    let menuIndex = Number(sessionStorage.getItem('yey-mineMenuIndex')) || 0
    this.menuIndex = menuIndex
  },
  methods: {
    toBack() {
      this.$router.back()
    },
    changeMenu(index) {
      this.menuIndex = index
      sessionStorage.setItem('yey-mineMenuIndex', index)
      if (index != 0) {
        sessionStorage.setItem('yey-teacherResourceIndex', 0)
      }
    },
    refreshImg() {
      this.userInfo = JSON.parse(localStorage.getItem('yey-user'))
    },
  },
}
</script>

<style lang="less" scoped>
.mine {
  padding: 0 40px 40px;
  .top-line {
    display: flex;
    height: 81px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }

  .content {
    display: flex;
  }
  .menu {
    width: 220px;
    min-height: calc(100vh - 221px);
    text-align: center;
    background: #ffffff;
    .teacher-img {
      width: 112px;
      height: 112px;
      margin: 19px 54px;
      border-radius: 56px;
    }
    .teacher-name {
      margin-top: 4px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 30px;
    }
    .teacher-school {
      padding-bottom: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #808080;
      line-height: 24px;
    }
    .menu-item {
      width: 220px;
      height: 80px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4d4d4d;
      line-height: 80px;
      cursor: pointer;
      user-select: none;
    }
    .cur-menu {
      color: #0da1f1;
      background: rgba(92, 203, 247, 0.2);
    }
  }

  .rel {
    position: relative;
    width: calc(100vw - 320px);
    min-height: calc(100vh - 221px);
    margin-left: 20px;
    background-color: #fff;
  }
}
</style>
